import { Spin } from 'antd';
import loadingImg from 'v3/assets/images/loading-icon.gif';

import * as S from './styles';

export type LoadingTypes = {
  load: boolean;
  children: React.ReactNode;
  size?: 'large' | 'default' | 'small';
};

const Loading = ({
  load = false,
  size = 'default',
  children,
}: LoadingTypes) => {
  const loadingIcon = <img src={loadingImg} alt="" />;

  return (
    <S.Wrapper>
      <Spin size={size} indicator={loadingIcon} spinning={load}>
        {children}
      </Spin>
    </S.Wrapper>
  );
};

export default Loading;
